
export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? '#f5f7fa' : '#fff', // Change background color when disabled
        cursor: state.isDisabled ? 'not-allowed' : 'default', // Change cursor when disabled
        border: state.isDisabled ? '1px solid #cbd5e1' : '1px solid #cbd5e1', // Change border when disabled
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isDisabled ? "#ffffff" : state.isFocused ? '#1967d2' : state.isSelected ? '#1967d2' : '#ffffff', // Change background based on state
        color: state.isDisabled ? "#475569" : state.isFocused ? '#ffffff' : state.isSelected ? "#ffffff" : '#475569', // Change text color on hover
        // padding: 10, // Add padding for better spacing
        padding: "0px 10px",
        minHeight: '25px', // Set height of each option
        lineHeight: '25px',
        display: "flex",
        alignItems: "center"
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: state.isDisabled ? "#b5bbc3" : "#475569", // Change text color when disabled
    }),
    // You can customize other parts like dropdown indicators, menu, etc., as needed
};

export const convertToOptions = (list, labelSourceKey = 'Name', valueSourceKey = "ID") => {
    return list.map(item => ({
        label: item[labelSourceKey],
        value: item[valueSourceKey]
    }));
};

export const convertToUserOptions = (list) => {
    if (list?.length > 0) {
        list.sort()
        return list.map(item => ({
            value: item,
            label: item
        }));
    }
    return []
};